<!-- Ride Along invitation — mirrors Flutter _showRideAlongInviteDialog glass card -->
<div class="ra-overlay" *ngIf="invitation || joining">
  <!-- Joining ("Retrieving Trip Details") state -->
  <div class="ra-card ra-joining" *ngIf="joining">
    <div class="ra-spinner"></div>
    <div class="ra-joining-text">Retrieving Trip Details…</div>
  </div>

  <!-- Invitation card -->
  <div class="ra-card" *ngIf="invitation && !joining">
    <div class="ra-header">
      <div class="ra-avatar">
        <img *ngIf="invitation.captain.imageUrl" [src]="invitation.captain.imageUrl" alt="" />
        <span class="ra-avatar-fallback" *ngIf="!invitation.captain.imageUrl">
          {{ (invitation.captain.displayName || '?').charAt(0).toUpperCase() }}
        </span>
      </div>
      <div class="ra-header-text">
        <div class="ra-captain">{{ invitation.captain.displayName || 'A captain' }}</div>
        <div class="ra-subtitle">Wants you on board</div>
      </div>
      <button class="ra-close" type="button" (click)="onDismiss()" aria-label="Dismiss">×</button>
    </div>

    <div class="ra-rows">
      <div class="ra-row">
        <span class="ra-label">Trip</span>
        <span class="ra-value">{{ invitation.tripName || '—' }}</span>
      </div>
      <div class="ra-row" *ngIf="invitation.tripType">
        <span class="ra-label">Type</span>
        <span class="ra-value ra-cap">{{ invitation.tripType }}</span>
      </div>
      <div class="ra-row">
        <span class="ra-label">Privacy</span>
        <span class="ra-value ra-cap">{{ invitation.privacy || 'N/A' }}</span>
      </div>
      <div class="ra-row">
        <span class="ra-label">Mates on trip</span>
        <span class="ra-value">{{ matesLabel(invitation.matesOnTrip) }}</span>
      </div>
    </div>

    <div class="ra-note">
      <span class="ra-note-icon">ⓘ</span>
      <span>You can add waypoints. Only the Captain can delete the trip or remove mates.</span>
    </div>

    <div class="ra-actions">
      <button class="ra-btn ra-decline" type="button" (click)="onDecline()">Decline</button>
      <button class="ra-btn ra-join" type="button" (click)="onJoin()">Join Trip</button>
    </div>
  </div>
</div>
